import { ActionReducer } from '@ngrx/store';
import { localStorageSync } from 'ngrx-store-localstorage';

const customStorage: Storage = {
  length: 0,
  setItem: function (key: string, data: string): void {
    try {
      window.localStorage.setItem(key, data);
      (this.length as any) = window.localStorage.length;
    } catch {
      return;
    }
  },
  getItem: function (key: string): any | null {
    try {
      return window.localStorage.getItem(key);
    } catch {
      return null;
    }
  },
  key: function (index: number): string | null {
    try {
      return window.localStorage.key(index);
    } catch {
      return null;
    }
  },
  clear: function (): void {
    if (window && window.localStorage) {
      window.localStorage.clear();
      (this.length as any) = window.localStorage.length;
    }
  },
  removeItem: function (key: string): void {
    try {
      window.localStorage.removeItem(key);
      (this.length as any) = window.localStorage.length;
    } catch {
      return;
    }
  }
};

// the keys from state which we'd like to save.
const stateKeys = ['questionnairesNavigation'];

export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return localStorageSync({
    keys: stateKeys,
    rehydrate: true,
    storage: customStorage
  })(reducer);
}
